// common app & mfe

import {useState, useRef, useEffect } from 'react';

// Icons
import IconChevron from "../../../../assets/icons/icon_chevron";


export interface IDropdownOption {
	value?: number | string,
	type?: string
	label?: string,
	data?: object,
	[key: string]: string | number | object | undefined;
}
export interface DropdownProps  {
	options: Array<IDropdownOption>,
	selectOption: Function,
	currentValue: number | string,
	placeholder?: string,
}

export function Dropdown(props: DropdownProps) {
	const ref = useRef<HTMLDivElement | null>(null);
	
	const options = props.options;
	const currentValue = props.currentValue;
	const placeholder = props.placeholder;

	const [open, setOpen] = useState<boolean>(false);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
		  	if (ref.current && !ref.current.contains(event.target as Node)) {
				setOpen(false)
		  	}
		};

		document.addEventListener('click', handleClickOutside, true);
		return () => {
		  document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	return (
		<div className="dropdown" onClick={() => setOpen(!open)} ref={ref}>
			<input className={`dropdown__input ${placeholder ? 'placeholder' : ''}`} type="text" placeholder="" value={currentValue} readOnly/>
			
			<div className="dropdown__placeholder">
				{ placeholder ? 
					<span className="dropdown__placeholder-label">{placeholder}</span>
				:''}
				<IconChevron />
			</div>

			{ open && options && options.length &&
				<div className="dropdown__container">

					{options.map((o, k) => {
						return (
							<div className={`dropdown__option ${ [o.label, o.value].includes(currentValue) ? 'current' : ''}`}data-value={o.value} data-key={k} key={k} onClick={() => (props.selectOption(o))}>
								{o.label || o.value}
							</div>
						)
					})}
				</div>
			}
		</div> 
	);
}

